import {
  Autocomplete,
  Checkbox,
  createFilterOptions,
  FormGroup,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Icon } from "@progress/kendo-react-common";
import { useNavigate, useParams, useLocation, NavLink } from "react-router-dom";
import { Breadcrumbs } from "../../AbstractElements";
import { Card, Col, Row } from "reactstrap";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Grid,
  Modal,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import ReactQuill from "react-quill";
import axios from "axios";
import { ShowError, ShowSucess } from "../../_helper/helper";
import { loadingPanel } from "../../CommonComponents/CommonFunction";
import Errorlable from "./Errorlable";


const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "link",
  "image",
  "video",
];
const AddNotificationTemplate = () => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(false);
  const [notificationText, setNotificationText] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [dashboardNotification, setDashboardNotification] = useState("");
  const [content, setContent] = useState("");
  const [selectAction, setSelectAction] = useState([]);
  const [selectEmail, setSelectEmail] = useState('N');
  const [selectDashboardNotification, setSelectDashboardNotification] = useState("Y");
  const [isActive, setIsActive] = useState(true)
  const [isApprove, setIsApprove] = useState('Approved')
  const params = useParams();
  const [selectLkProcess, setSelectLkProcess] = useState({
    label: "",
    value: null,
  });
  const [selectLKProcessId, setSelectLKProcessId] = useState({
    label: "",
    value: null,
  });
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [LKProcessOption, setLKProcessOption] = useState([]);
  const [allRoles, setAllRoles] = useState([]);
  const [filterRoles, setFilterRoles] = useState([]);
  const [LKProcessStatusOptionAll, setLKProcessStatusOptionAll] = useState([]);
  const [filterLKProcessStatusOption, setFilterLKProcessStatusOptionAll] = useState([]);
  const navigate = useNavigate()

  const hanldeContentChange = (html) => {
    setContent(html);
  };

  const getLKProcess = () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    // vw_payperiod_master
    const payload = {
      tableName: "LK_Process",
      searchParams: `[]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 500,
      sortData: "",
      additionalWhere: "IsDeleted is NULL",
      qID: 0,
      orderby: "ProcessName",
      location: "global",
      id: "",
    };
    axios
      .post(`${newBaseURL}/AdvanceSearch/Global`, payload, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${localStorage.getItem(
          //   "jwt_access_token"
          // )}`,
          Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
        },
      })
      .then((response) => {
        // let createObj = [];
        let finalData = response?.data?.results;
        if (finalData?.length) {
          let LKProcesses = finalData?.map((i) => {
            return { label: i.ProcessName, value: i.ID };
          });

          setLKProcessOption(LKProcesses);
        }
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });
  };

  const getLK_ProcessStatus = () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    // vw_payperiod_master
    const payload = {
      tableName: "LK_ProcessStatus",
      searchParams: `[]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 500,
      sortData: "",
      additionalWhere: "",
      qID: 0,
      orderby: "Seq",
      location: "global",
      id: "",
    };
    axios
      .post(`${newBaseURL}/AdvanceSearch/Global`, payload, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${localStorage.getItem(
          //   "jwt_access_token"
          // )}`,
          Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
        },
      })
      .then((response) => {
        // let createObj = [];
        let finalData = response?.data?.results;

        if (finalData?.length) {
          let LKProcesses = finalData?.map((i) => {
            return { label: i.StatusName, value: i.ID, ProcessID: i.ProcessID, AllowedRole: i.AllowedRole ? i.AllowedRole.split(',') : [] };
          });

          setLKProcessStatusOptionAll(LKProcesses);
        }
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });
  };
  const getAllRoles = () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    // vw_payperiod_master
    const payload = {
      tableName: "Roles",
      searchParams: `[]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 500,
      sortData: "Name asc",
      additionalWhere: "",
      qID: 0,
      orderby: "",
      location: "global",
      id: "",
    };
    axios
      .post(`${newBaseURL}/AdvanceSearch/Global`, payload, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${localStorage.getItem(
          //   "jwt_access_token"
          // )}`,
          Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
        },
      })
      .then((response) => {
        // let createObj = [];
        let finalData = response?.data?.results;

        if (finalData?.length) {
          let roles = finalData?.map((i) => {
            return { label: i.Name, value: i.Name };
          });

          setAllRoles(roles);
        }
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
      });
  };

  useEffect(() => {
    getLKProcess();
    getLK_ProcessStatus();
    getAllRoles();
  }, []);

  useEffect(() => {
    if (selectLkProcess?.value && LKProcessStatusOptionAll?.length) {
      let finalData = LKProcessStatusOptionAll?.filter(
        (i) => i.ProcessID == selectLkProcess?.value
      );
      setFilterLKProcessStatusOptionAll(finalData);
    } else {
      setFilterLKProcessStatusOptionAll([]);
      setSelectLKProcessId({ label: "", value: "" });
    }
  }, [selectLkProcess]);

  const handleAddTemplates = () => {
    const error = handleValidate()
    console.log("dadadadadad", error);

    if (Object.keys(error)?.length) {
      console.log("dadadadadad in", error);
      ShowError('Please check errors')
      return
    }
    setLoading(true);
    let payload = {
      templateName: notificationText,
      emailSubject: emailSubject,
      templateBody: dashboardNotification,
      templateEmailBody: content,
      processId: selectLkProcess?.value,
      email: selectEmail,
      processStatusId: selectLKProcessId?.value,
      dashboard: selectDashboardNotification,
      nonActionRequired: selectedRoles?.length
        ? JSON.stringify(selectedRoles)
        : "",
      actionRequiredRole: selectAction?.length ? JSON.stringify(selectAction) : '',
      isActive: isActive,
      approvedFlag: isApprove
    };

    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    let APIURL = `${newBaseURL}/NotificationTemplate/NotificationCreate`;
    if (params?.id) {
      APIURL = `${newBaseURL}/NotificationTemplate/NotificationTemplateUpdated`;
      payload.id = params?.id;
      axios
        .put(APIURL, payload, {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${localStorage.getItem(
            //   "jwt_access_token"
            // )}`,
            Authorization: `Bearer ${sessionStorage.getItem(
              "jwt_access_token"
            )}`,
          },
        })
        .then((response) => {
          ShowSucess("Template Updated Succesfully");
          // handleGetDataById(params?.id);
          setLoading(false);
          navigate('/notification-template-list')
        })
        .catch((error) => {
          console.warn("Cannot retrieve user data", error);
          setLoading(false);
        });
      return;
    }
    axios
      .post(APIURL, payload, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${localStorage.getItem(
          //   "jwt_access_token"
          // )}`,
          Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
        },
      })
      .then((response) => {
        ShowSucess("Template Created Succesfully");
        // handleGetDataById(params?.id);
        setLoading(false);
        navigate('/notification-template-list')

      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (
      params?.id &&
      LKProcessOption?.length &&
      LKProcessStatusOptionAll?.length
    ) {
      handleGetDataById(params?.id);
    }
  }, [params?.id, LKProcessOption, LKProcessStatusOptionAll]);

  const handleGetDataById = (id) => {
    setLoading(true);

    const payload = {
      tableName: "vw_template_management",
      searchParams: `[]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 500,
      sortData: "",
      additionalWhere: `ID = ${id}`,
      qID: 0,
      orderby: "ID",
      location: "global",
      id: "",
    };
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    axios
      .post(`${newBaseURL}/AdvanceSearch/Global`, payload, {
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${localStorage.getItem(
          //   "jwt_access_token"
          // )}`,
          Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
        },
      })
      .then((response) => {
        setLoading(false);
        let datas = response?.data?.results?.length
          ? response?.data.results[0]
          : {};

        let LkProcessShow = LKProcessOption?.find(
          (i) => i.value == datas?.ProcessID
        );
        let LkProcessShowId = LKProcessStatusOptionAll?.find(
          (i) => i.value == datas?.ProcessStatusID
        );
        setIsActive(datas.isActive)
        setIsApprove(datas.ApprovedFlag)
        setNotificationText(datas?.TemplateName);
        setDashboardNotification(datas?.TemplateBody);
        setSelectEmail(datas?.Email == "Y" ? "Y" : "N");
        setSelectDashboardNotification(datas?.Dashboard == "Y" ? "Y" : "N");
        setEmailSubject(datas?.EmailSubject);
        setSelectLkProcess(LkProcessShow);
        setSelectLKProcessId(LkProcessShowId);

        setContent(datas?.TemplateEmailBody);
        setLoading(false);
        setSelectedRoles(datas?.NonActionRequired ? JSON.parse(datas?.NonActionRequired) : []);
        setSelectAction(datas?.ActionRequiredRole ? JSON.parse(datas?.ActionRequiredRole) : []);
      })
      .catch((error) => {
        console.warn("Cannot retrieve user data", error);
        ShowError('No data found')
        setLoading(false);
      });
  };

  const handleValidate = () => {
    let error = {}
    if (!notificationText) {
      error.templateName = '* Templatename is required'
    }
    if (selectDashboardNotification == 'N' && selectEmail == 'N') {
      error.deliveryOption = 'Please select delivery option'
    }
    if (selectDashboardNotification == 'Y' && !dashboardNotification) {
      error.dashboardNotification = '* Dashboard notification is required'
    }
    if (selectEmail == 'Y' && !emailSubject) {
      error.emailSubject = '* EmailSubject is required'
    }
    if (selectEmail == 'Y' && !content) {
      error.emailBody = 'EmailBody is required'
    }
    if (!selectLkProcess?.value) {
      error.Lkprocess = '* Process is required'
    }
    if (!selectLKProcessId?.value) {
      error.LkprocessId = '* Workflow is required'
    }
    if (!selectedRoles?.length) {
      error.selectRoles = '* Role is required'
    }
    // if(selectedRoles?.length && !selectAction?.length){
    //   error.actionRequired = 'ActionRequired is required'
    // }
    console.log("Dadaadadasdasd", error);
    setErrors(error)
    return error

  }


  useEffect(() => {
    if (allRoles.length && selectLKProcessId && Object.keys(selectLKProcessId).length) {
      const newFilterRoles = allRoles.filter(i => selectLKProcessId?.AllowedRole?.includes(i.value))
      if (newFilterRoles?.length) {
        setFilterRoles(newFilterRoles)
      } else {
        setFilterRoles([])
      }
    } else {
      setFilterRoles([])
    }

  }, [selectLKProcessId, allRoles])

  return (
    <div>
      {loading && loadingPanel()}
      <Breadcrumbs
        mainTitle={
          <Typography variant="h5">
            <Icon
              style={{ fontSize: "25px", margin: "10px" }}
              name="list-latin-small"
            />
            Notification Template
          </Typography>
        }
        parent={
          // <NavLink
          //   to={`${process.env.PUBLIC_URL}/employee-master`}
          //   className="font-light"
          // >
          //   Employee Master
          // </NavLink>

          <NavLink
            to={`${process.env.PUBLIC_URL}/npa-records`}
            className="font-light"
          >
            Notification Template
          </NavLink>
        }
        title={"New"}
      />

      <Card className="p-3">
        <Row>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <FormControl >
              <b>Template Status</b>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="isActive"
                value={isActive}
                onChange={(e) => { setIsActive(e.target.value) }}
              >
                <FormControlLabel
                  value={true}
                  control={<Radio />}
                  label="Active"
                />
                <FormControlLabel
                  value={false}
                  control={<Radio />}
                  label="Inactive"
                />
              </RadioGroup>
            </FormControl>

            <div>
              <Button
                variant="contained"
                // variant="contained"
                className="bg-primary"
                style={{
                  color: "white",
                  marginBottom: "10px",
                }}
                onClick={handleAddTemplates}
              >
                {params?.id ? "Update Template" : "Save Template"}
              </Button>
            </div>
          </div>
        </Row>
        <Row>
          <Col md={12}>
            <TextField
              fullWidth
              size="small"
              autoComplete="off"
              inputProps={{
                maxLength: 200,
              }}
              margin="dense"
              variant="outlined"
              label={"Template Name"}
              //   multiline
              rows={3}
              value={notificationText}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => {
                setNotificationText(e.target.value);
              }}
              error={errors?.templateName ? true : false}
              helperText={errors?.templateName || null}
            />
          </Col>
          <Col md={12} className="mt-2">
            <div>
              <b>Choose Delivery Option:</b>
            </div>
            <div>
              <FormGroup style={{ display: "contents" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        selectDashboardNotification == "Y" ? true : false
                      }

                      onChange={(e) => {
                        setSelectDashboardNotification(
                          e.target.checked ? "Y" : "N"
                        )
                        if (!e.target.checked) {
                          setDashboardNotification('')

                        }
                      }
                      }
                    />
                  }
                  label={"Dashboard Notification"}
                />
                <FormControlLabel

                  control={
                    <Checkbox
                      checked={selectEmail == "Y" ? true : false}

                      onChange={(e) => {
                        setSelectEmail(e.target.checked ? "Y" : "N")
                        if (!e.target.checked) {
                          setEmailSubject('')
                          setContent('')
                        }
                      }
                      }
                    />
                  }
                  label={"Email"}
                />
              </FormGroup>
              {errors?.deliveryOption ?
                <Errorlable text={errors?.deliveryOption} /> : null}

            </div>
          </Col>
          <Row>
            <Col md={4}>
              <Autocomplete
                disablePortal
                size="small"
                className="mt-3"
                fullWidth
                value={selectLkProcess}
                getOptionLabel={(option) => option.label}
                options={LKProcessOption?.length ? LKProcessOption : []}
                onChange={(e, value) => {
                  setSelectLkProcess(value);
                  setSelectLKProcessId({ label: '', value: '' })
                }}

                renderInput={(params) => (
                  <TextField {...params} label="Process"
                    error={errors?.Lkprocess ? true : false}
                    helperText={errors?.Lkprocess || null}
                  />
                )}
              />
            </Col>
            <Col md={4}>
              <Autocomplete
                disablePortal
                size="small"
                className="mt-3"
                fullWidth
                value={selectLKProcessId}
                getOptionLabel={(option) => option.label}
                options={
                  filterLKProcessStatusOption?.length
                    ? filterLKProcessStatusOption
                    : []
                }
                onChange={(e, value) => {
                  setSelectLKProcessId(value);
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Workflow Name"
                    error={errors?.LkprocessId ? true : false}
                    helperText={errors?.LkprocessId || null}
                  />
                )}
              />
            </Col>
            {[100, 31, 1, 2].includes(selectLkProcess?.value) && <Col md={12}>
              <FormControl className="pt-2">
                <b>Approve Status</b>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="isApprove"
                  value={isApprove}
                  onChange={(e) => { setIsApprove(e.target.value) }}
                >
                  <FormControlLabel
                    value={"Approved"}
                    control={<Radio />}
                    label="Approve"
                  />
                  <FormControlLabel
                    value={"Return"}
                    control={<Radio />}
                    label="Return"
                  />
                  <FormControlLabel
                    value={"Update"}
                    control={<Radio />}
                    label="Update"
                  />
                  <FormControlLabel
                    value={"Forward"}
                    control={<Radio />}
                    label="Forward"
                  />
                </RadioGroup>
              </FormControl>
            </Col>}
            <Col md={12}>
              <Autocomplete
                multiple
                size="small"
                className="mt-3"
                options={filterRoles?.map((option) => option.label)}
                value={selectedRoles}
                onChange={(e, value) => {

                  setSelectedRoles(value);
                }}
                filterOptions={createFilterOptions({
                  matchFrom: "any",
                  limit: 100,
                })}
                // defaultValue={[jobOptionsList[0]]}
                filterSelectedOptions
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Roles"
                    placeholder="Select Roles"
                    variant="outlined"
                    size="small"
                    error={errors?.selectRoles ? true : false}
                    helperText={errors?.selectRoles || null}
                  />
                )}
              />
            </Col>

            <Col md={12} className="mt-2">
              <div>
                {selectedRoles?.length ? <b>Action Required For</b> : null}
              </div>
              <div style={{ display: "flex" }}>
                {selectedRoles?.map((i, index) => {
                  return (
                    <FormGroup key={index}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectAction?.includes(i) ? true : false}
                            onChange={(e) => {
                              // let check = [...selectAction] //for multiple selection
                              let check = [];
                              if (!selectAction.includes(i)) {
                                check.push(i);
                              } else {
                                check = check.filter((k) => k !== i);
                              }
                              setSelectAction(check);
                            }}
                          />
                        }
                        label={i}
                      />
                    </FormGroup>

                  );
                })}

              </div>
              {errors?.actionRequired ?
                <Errorlable text={errors?.actionRequired} /> : null}
            </Col>
          </Row>
          {selectDashboardNotification == "Y" ? (
            <Col>
              <TextField
                fullWidth
                size="small"
                autoComplete="off"
                inputProps={{
                  maxLength: 200,
                }}
                margin="dense"
                variant="outlined"
                label={"Notification Text"}
                multiline
                rows={3}
                value={dashboardNotification}
                InputLabelProps={{ shrink: true }}
                onChange={(e) => {
                  setDashboardNotification(e.target.value);
                }}
                error={errors?.dashboardNotification ? true : false}
                helperText={errors?.dashboardNotification || null}
              />
            </Col>
          ) : null}
          {selectEmail == "Y" ? (
            <Col md={12}>
              <div>
                <TextField
                  fullWidth
                  size="small"
                  autoComplete="off"
                  inputProps={{
                    maxLength: 200,
                  }}
                  margin="dense"
                  variant="outlined"
                  label={"Email Subject"}
                  //   multiline
                  rows={3}
                  value={emailSubject}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => {
                    setEmailSubject(e.target.value);
                  }}
                  error={errors?.emailSubject ? true : false}
                  helperText={errors?.emailSubject || null}
                />
                <div className="mt-1">
                  <b>Email Tamplate Body :</b>
                </div>
                <ReactQuill
                  theme="snow"
                  value={content}
                  onChange={hanldeContentChange}
                  modules={modules}
                  formats={formats}
                  style={{
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    minHeight: "300px",
                    maxHeight: "300px",
                    overflowY: "auto",
                  }}
                />
                {errors?.emailBody ?
                  <Errorlable text={errors?.emailBody} /> : null}
              </div>
            </Col>
          ) : null}
        </Row>

      </Card>
    </div>
  );
};

export default AddNotificationTemplate;
